import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import './Resume.css'

function Resume_Certificate() {
    const isSmallScreen = window.innerWidth <= 300;
    
    return (
        <Card className={"resume-card"}>
            <h1 className={"resume-card-title"}>Certificates</h1>
            <br></br>
            <Row>
                {/* 첫 번째 열 (연도) */}
                <Col xs={isSmallScreen ? 4 : 3} className="text-center res-year">
                    <Row>
                        <p> 2024.06 </p>
                    </Row>

                    <Row>
                        <p> 2023.08 </p>
                    </Row>

                    <Row>
                        <p> 2023.05 </p>
                    </Row>

                    <Row>
                        <p> 2022.03 </p>
                    </Row>

                    <Row>
                        <p> 2021.08 </p>
                    </Row>

                    <Row>
                        <p> 2021.04 </p>
                    </Row>

                    <Row>
                        <p> 2021.04 </p>
                    </Row>

                    <Row>
                        <p> 2020.09 </p>
                    </Row>
                </Col>
                {/* 두 번째 열 (세로 선) */}
                <Col xs={1} className="text-center">
                    <div className="vertical-line"></div>
                </Col>
                {/* 세 번째 열 */}
                <Col xs={isSmallScreen ? 6 : 4} className="text-center res-edu-text">
                    <Row>
                        <p> Big Data Analyst </p> <br></br>
                    </Row>
                    <Row>
                        <p> AWS SAA </p> <br></br>
                    </Row>
                    <Row>
                        <p> DAsP </p> <br></br>
                    </Row>
                    <Row>
                        <p> ADsP </p> <br></br>
                    </Row>
                    <Row>
                        <p> Information Processing Engineer </p> <br></br>
                    </Row>
                    <Row>
                        <p> Linux Master 2nd Grade </p> <br></br>
                    </Row>
                    <Row>
                        <p> SQLD </p> <br></br>
                    </Row>
                    <Row>
                        <p> Computer Proficiency 2nd Grade </p>
                    </Row>
                </Col>

                {/* 네 번째 열 */}
                {!isSmallScreen && (
                    <Col xs={4} className="text-center res-edu-text">
                        <Row>
                            <p> Korea Data Industry Promotion Agency </p> <br></br>
                        </Row>
                        <Row>
                            <p> AWS </p> <br></br>
                        </Row>
                        <Row>
                            <p> Korea Data Industry Promotion Agency </p> <br></br>
                        </Row>
                        <Row>
                            <p> Korea Data Industry Promotion Agency </p> <br></br>
                        </Row>
                        <Row>
                            <p> Korea Industrial Human Resources Development Corporation </p> <br></br>
                        </Row>
                        <Row>
                            <p> Korea Information & Communications Technology Association </p> <br></br>
                        </Row>
                        <Row>
                            <p> Korea Data Industry Promotion Agency </p> <br></br>
                        </Row>
                        <Row>
                            <p> Korea Chamber of Commerce & Industry </p>
                        </Row>
                    </Col>
                )}
            </Row>
        </Card>
    )
}

export default Resume_Certificate;
